/**
 * Created by Tiger on 04/03/2022.
 */
import {Form, Input} from 'antd';
import React from 'react';

export const InputItem = item => {
  const { label = '', style = {}, onChange, ...inputParams } = item;
  return (<Form.Item required={true} style={ { marginTop: label ? 15 : 0, ...style } }>
    <label>{ label }</label>
    <Input style={ { marginTop: label ? 10 : 0 } } { ...inputParams } onChange={ event => onChange?.(event) }
           allowClear={ true }/>
  </Form.Item>);
};